module.exports = __webpack_public_path__ + "static/img/show_status.e520bd27.png";